<template>
  <svg
    width="14"
    height="7"
    viewBox="0 0 14 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.646876 0.148809C0.693316 0.102257 0.748487 0.0653237 0.809224 0.0401236C0.869963 0.0149236 0.935076 0.00195257 1.00084 0.00195258C1.06659 0.00195258 1.13171 0.0149237 1.19245 0.0401237C1.25318 0.0653237 1.30835 0.102257 1.35479 0.148809L7.00013 5.79437L12.6455 0.148809C12.692 0.102333 12.7471 0.0654662 12.8079 0.0403136C12.8686 0.0151609 12.9337 0.00221496 12.9994 0.00221496C13.0652 0.00221497 13.1303 0.0151609 13.191 0.0403136C13.2517 0.0654663 13.3069 0.102333 13.3534 0.148809C13.3999 0.195285 13.4367 0.25046 13.4619 0.311184C13.4871 0.371908 13.5 0.436992 13.5 0.502719C13.5 0.568446 13.4871 0.63353 13.4619 0.694254C13.4367 0.754978 13.3999 0.810153 13.3534 0.856629L7.35409 6.8551C7.30765 6.90165 7.25248 6.93858 7.19174 6.96378C7.131 6.98898 7.06589 7.00195 7.00013 7.00195C6.93437 7.00195 6.86926 6.98898 6.80852 6.96378C6.74778 6.93858 6.69261 6.90165 6.64617 6.8551L0.646876 0.856628C0.600319 0.810194 0.56338 0.755033 0.538177 0.694303C0.512974 0.633574 0.5 0.568469 0.5 0.502718C0.5 0.436968 0.512974 0.371863 0.538177 0.311134C0.56338 0.250404 0.600319 0.195242 0.646876 0.148809Z"
      fill="#A3A3A3"
    />
  </svg>
</template>